import { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { setListError } from "../../../context/Actions/registro/registro";
import { validaMobile } from "../../../context/Actions/registro/validaMobile";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import {
  resetPaciente,
  wsPostActualizarClave,
} from "../../../context/Actions/paciente/paciente";
import { useFocus } from "../../../customHooks/useFocus";
import isEmptyError, {
  isErrorEmail,
  isLocalidadError,
} from "../../../../global/utils/isEmptyError";
import preventKeyEmail, {
  preventKeyTelefono,
} from "../../../../global/utils/preventKey";
import { regexNumero } from "../../../../global/utils/expresionesRegulares";
import { editarPaciente } from "../../../context/Actions/paciente/paciente";
import React from "react";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import isPwdValido from "../../../../global/utils/checkPwdValido";
import camelize from "../../../../global/utils/camelize";
import "./DatosPersonalesStyle.css";
import HidePassIcon from "../../../assets/images/generico/HidePassIcon";
import ShowPassIcon from "../../../assets/images/generico/ShowPassIcon";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";

const DatosPersonales = () => {
  const hoy = new Date();
  const {
    localidadState,
    registroState,
    registroDispatch,
    validaMobileDispatch,
    validaMobileState,
    pacienteDispatch,
    pacienteState,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { toasterDispatch } = useContext(GlobalContext);

  const [passwordShown, setPasswordShown] = useState(false);
  const [deshabilitaFormulario, setDesahabilitaFormulario] = useState(false);
  const [deshabilitaPwd, setDeshabilitaPwd] = useState(false);
  const [valueActual, setValueActual] = useState("");
  const [valuePwd, SetValuePwd] = useState("");
  const [pwdError, setPwdError] = useState(false);
  const [actualError, setActualError] = useState(false);
  const [changeBotones, setChangeBotones] = useState(false);
  const [linkStr, setLinkStr] = useState("Cambiar contraseña");
  const [formularioPerfil, setformularioPerfil] = useState({
    nombre: pacienteState.paciente.datosActualizados.nombre,
    domicilio: camelize(pacienteState.paciente.datosActualizados.domicilio),
    telefono: pacienteState.paciente.datosActualizados.telefono,
    codigo_postal: pacienteState.paciente.datosActualizados.codigo_postal,
    fecha_nacimiento: pacienteState.paciente.datosActualizados.fecha_nacimiento,
    sexo: pacienteState.paciente.datosActualizados.sexo,
    email: pacienteState.paciente.datosActualizados.email,
    telefono_movil: pacienteState.paciente.datosActualizados.telefono_movil,
    idlocalidad: pacienteState.paciente.datosActualizados.idLocalidad,
    localidad_desc: camelize(
      pacienteState.paciente.datosActualizados.localidad
    ),
    cobertura: {
      OSInactiva: pacienteState.paciente.datosActualizados.cobertura.osInactiva,
      OSNoDaConsulta:
        pacienteState.paciente.datosActualizados.cobertura.osNoDaConsulta,
      OSNoDaEstudios:
        pacienteState.paciente.datosActualizados.cobertura.osNoDaEstudios,
      PlanInactivo:
        pacienteState.paciente.datosActualizados.cobertura.planInactivo,
      idCobertura:
        pacienteState.paciente.datosActualizados.cobertura.idCobertura,
      idCoberturaPlan:
        pacienteState.paciente.datosActualizados.cobertura.idCoberturaPlan,
      cobertura: pacienteState.paciente.datosActualizados.cobertura.cobertura,
      plan: pacienteState.paciente.datosActualizados.cobertura.plan,
      afiliado: pacienteState.paciente.datosActualizados.cobertura.afiliado,
    },
  });
  //eslint-disable-next-line
  const [perfilEstadoInicial, setPerfilEstadoInicial] =
    useState(formularioPerfil);

  //cancelo y vuelvo al estado inicial
  useEffect(() => {
    if (
      !pacienteState.paciente.editaPerfil.estado &&
      !pacienteState?.paciente?.loading
    ) {
      setformularioPerfil(perfilEstadoInicial);
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.editaPerfil.estado]);

  //guardo y cambio el estado inicial con los nuevos datos
  useEffect(() => {
    if (pacienteState.paciente.datosActualizados !== null) {
      setPerfilEstadoInicial(pacienteState.paciente.datosActualizados);
      setformularioPerfil(pacienteState.paciente.datosActualizados);
    }
  }, [pacienteState.paciente.datosActualizados]);

  //eslint-disable-next-line
  const [txtActual, setTxtActual] = useFocus();
  const [txtPwdMobile, setTxtPwdMobile] = useFocus();
  const [txtPwd, setTxtPwd] = useFocus();

  const showPassword = () => {
    setPasswordShown(true);
  };
  const hidePassword = () => {
    setPasswordShown(false);
  };

  const onFechaNacChange = (e) => {
    let usuario = Object.assign(
      {},
      pacienteState.paciente.editaPerfil.editarPaciente
    );
    let errx = Object.assign({}, registroState.registro.listError);
    if (e !== null) {
      usuario.fecha_nacimiento = e + "T00:00:00";
      setformularioPerfil({
        ...formularioPerfil,
        fecha_nacimiento: e + "T00:00:00",
      });
      editarPaciente(usuario)(pacienteDispatch);
      errx.fecha_nacimiento = false;
      setListError(errx)(registroDispatch);
    } else {
      usuario.fecha_nacimiento = "";
      editarPaciente(usuario)(pacienteDispatch);
      errx.fecha_nacimiento = true;
      setListError(errx)(registroDispatch);
    }
  };

  //escucha todos los inputs menos Datepicker y Localidad
  const onInputChange = (e) => {
    let usuario = Object.assign(
      {},
      pacienteState.paciente.editaPerfil.editarPaciente
    );
    let errx = Object.assign({}, registroState.registro.listError);
    if (e.target.name === "telefono_movil")
      validaMobile(e.target.value)(validaMobileDispatch); //valida contra el ws, cambiar esto
    if (e.target.name === "email") {
      setListError({
        ...errx,
        [e.target.name]: isErrorEmail(e.target.value),
      })(registroDispatch);
    } else {
      setListError({
        ...errx,
        [e.target.name]: isEmptyError(e.target.value),
      })(registroDispatch);
    }
    setformularioPerfil({
      ...formularioPerfil,
      [e.target.name]: e.target.value,
    });
    editarPaciente({
      ...usuario,
      [e.target.name]: e.target.value,
    })(pacienteDispatch);
  };

  const onLocalidadChange = (e) => {
    let usuario = Object.assign(
      {},
      pacienteState.paciente.editaPerfil.editarPaciente
    );
    let errx = Object.assign({}, registroState.registro.listError);
    if (e !== undefined) {
      if (e === "") {
        errx.idlocalidad = isLocalidadError(e);
        setListError(errx)(registroDispatch);
        usuario.idlocalidad = "";
        setformularioPerfil({
          ...formularioPerfil,
          idlocalidad: "",
          localidad_desc: "",
        });
        editarPaciente(usuario)(pacienteDispatch);
      } else {
        errx.idlocalidad = isLocalidadError(e);
        setListError(errx)(registroDispatch);
        usuario.idlocalidad = e.id;
        usuario.localidad_desc = e.descripcion;
        setformularioPerfil({
          ...formularioPerfil,
          idlocalidad: e.id,
          localidad_desc: e.descripcion,
        });
        editarPaciente(usuario)(pacienteDispatch);
      }
    }
  };

  const habilitaCambioPwd = () => {
    setDeshabilitaPwd(false);
    setChangeBotones(true);
    setTimeout(() => {
      txtActual.current?.focus();
    }, 1);
  };

  const cancelaCambioPwd = () => {
    setChangeBotones(false);
    setDeshabilitaPwd(true);
    setValueActual("");
    SetValuePwd("");
    setPwdError(false);
    setActualError(false);
  };

  const getIdPaciente = () => {
    if (pacienteState?.paciente?.userSelect?.pacienteSeleccionado) {
      return pacienteState.paciente.userSelect.pacienteSeleccionado.id;
    }
    return 0;
  };

  const cambioClave = () => {
    const actualValida = valueActual && valueActual.length >= 4 && valueActual.length <= 10;
    const nuevaValida = valuePwd && valuePwd.length >= 4 && valuePwd.length <= 10;
    if (!actualValida) {
      setActualError(true);
      showToaster(
        { texto: "Ingresá la contraseña actual", tipo: "danger" },
        "centroArriba"
      )(toasterDispatch);
      return;
    }
    if (!nuevaValida) {
      setPwdError(true);
      showToaster(
        { texto: "La nueva contraseña debe tener entre 4 y 10 dígitos numéricos", tipo: "danger" },
        "centroArriba"
      )(toasterDispatch);
      return;
    }
    wsPostActualizarClave(valueActual, valuePwd, getIdPaciente())(pacienteDispatch);
  };

  const onChangeActual = (e) => {
    const newValue = (e.target.value || "").replace(/\D/g, "").slice(0, 10);
    setValueActual(newValue);
    if (newValue.length >= 4 && newValue.length <= 10) setActualError(false);
  };

  const onBlurActual = (e) => {
    const val = (e.target.value || "").replace(/\D/g, "");
    if (val.length > 0 && val.length < 4) setActualError(true);
    else setActualError(false);
  };

  const onChangePwd = (e) => {
    const rawValue = e.target.value;
    const newValue = rawValue.replace(/\D/g, "").slice(0, 10);
    SetValuePwd(newValue);
    if (newValue.length >= 4 && newValue.length <= 10) {
      setPwdError(false);
    }
  };

  const onBlurPwd = (e) => {
    const val = (e.target.value || "").replace(/\D/g, "");
    if (val.length > 0 && val.length < 4) {
      setPwdError(true);
    } else {
      setPwdError(false);
    }
  };

  const preventKeySoloNumerosPwd = (e) => {
    if (e.key.length > 1) return;
    if (!regexNumero.test(e.key)) e.preventDefault();
  };

  const onClickChangePwdMobile = (e) => {
    if (!pacienteState.paciente.userSelect.pacienteSeleccionado) {
      setDeshabilitaPwd(false);
      setChangeBotones(true);
      setTimeout(() => {
        txtActual.current?.focus();
      }, 1);
    } else {
      showToaster(
        {
          texto:
            "No es posible cambiar la contraseña de un familiar actualmente",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const onClickSavePwdMobile = () => {
    const actualValida = valueActual && valueActual.length >= 4 && valueActual.length <= 10;
    const nuevaValida = valuePwd && valuePwd.length >= 4 && valuePwd.length <= 10;
    if (!actualValida) {
      setActualError(true);
      showToaster({ texto: "Ingresá la contraseña actual", tipo: "danger" }, "centroArriba")(toasterDispatch);
      return;
    }
    if (!nuevaValida) {
      setPwdError(true);
      showToaster({ texto: "La nueva contraseña debe tener entre 4 y 10 dígitos numéricos", tipo: "danger" }, "centroArriba")(toasterDispatch);
      return;
    }
    wsPostActualizarClave(valueActual, valuePwd, getIdPaciente())(pacienteDispatch);
  };

  const onClickCancelPwdMobile = () => {
    setChangeBotones(false);
    setDeshabilitaPwd(true);
    setValueActual("");
    SetValuePwd("");
  };

  // cargo datos en objeto global -- este se va a utilizar para editar
  useEffect(() => {
    if (pacienteState.paciente.editaPerfil.estado) {
      editarPaciente(formularioPerfil)(pacienteDispatch);
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.editaPerfil.estado]);

  useEffect(() => {
    if (
      validaMobileState.validaMobile.data !== null &&
      validaMobileState.validaMobile.data !== undefined
    ) {
      let errx = Object.assign({}, registroState.registro.listError);
      errx.telefono_movil = !validaMobileState.validaMobile.data;
      if (!validaMobileState.validaMobile.data) {
        errx.telefono_movil = true;
        setListError(errx)(registroDispatch);
      } else {
        errx.telefono_movil = false;
        setListError(errx)(registroDispatch);
      }
    }
    //eslint-disable-next-line
  }, [validaMobileState.validaMobile]);

  useEffect(() => {
    setDesahabilitaFormulario(true);
    setDeshabilitaPwd(true);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (pacienteState.paciente.editaPerfil.estado) {
      setDesahabilitaFormulario(false);
    } else {
      setDesahabilitaFormulario(true);
      setChangeBotones(false);
      setDeshabilitaPwd(true);
      setValueActual("");
      SetValuePwd("");
    }
  }, [pacienteState]);

  useEffect(() => {
    if (
      pacienteState.paciente.cambioClave !== null &&
      pacienteState.paciente.cambioClave !== undefined &&
      pacienteState.paciente.cambioClave !== ""
    ) {
      if (pacienteState.paciente.cambioClave.origen === "cambioClave") {
        showToaster(
          {
            texto: "El cambio de Contraseña se realizo correctamente",
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
        setChangeBotones(false);
        setDeshabilitaPwd(true);
        setValueActual("");
        SetValuePwd("");
        setPwdError(false);
        setActualError(false);
        resetPaciente()(pacienteDispatch);
      }
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.cambioClave]);

  useEffect(() => {
    if (
      pacienteState.paciente.error !== null &&
      pacienteState.paciente.error !== undefined &&
      pacienteState.paciente.error.origen === "cambioClave" &&
      pacienteState.paciente.error !== false
    ) {
      if (
        pacienteState.paciente.error.status !== null &&
        pacienteState.paciente.error.status !== undefined &&
        pacienteState.paciente.error.origen === "cambioClave"
      ) {
        showToaster(
          {
            texto:
              pacienteState.paciente.error.texto !== ""
                ? pacienteState.paciente.error.texto
                : "La contraseña es incorrecta",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
      resetPaciente()(pacienteDispatch);
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.error]);

  function fechaMenos119Anios() {
    const hoy = new Date();
    const fechaResultante = new Date(
      hoy.getFullYear() - 119,
      hoy.getMonth(),
      hoy.getDate()
    );
    const anio = fechaResultante.getFullYear();
    const mes = String(fechaResultante.getMonth() + 1).padStart(2, "0"); // Meses en JavaScript son 0-11
    const dia = String(fechaResultante.getDate()).padStart(2, "0");
    return `${anio} ${mes} ${dia}`;
  }

  return (
    <React.Fragment>
      <div className="ptur-datos-personales-container">
        <div className="ptur-datos-personales-columna1">
          <div className="ptur-datos-personales-columna1-fila1">
            <DatePicker
              fechaInicial={fechaMenos119Anios()}
              fechaFinal={`${hoy.getFullYear()} ${
                hoy.getMonth() + 1
              } ${hoy.getDate()}`}
              headerStr="Fecha de nacimiento"
              onChange={onFechaNacChange}
              disable={deshabilitaFormulario}
              selectedFecha={formularioPerfil.fecha_nacimiento}
              isRequired={false}
            />
          </div>
          <div className="ptur-datos-personales-columna1-fila2">
            <Dropdown
              headerStr="Localidad"
              name="txtLocalidad"
              campoCodigo="id"
              descripcion="descripcion"
              datos={localidadState.localidad.data}
              onChange={onLocalidadChange}
              valor={formularioPerfil.idLocalidad}
              errorStr="Seleccione una localidad de la lista"
              checkError={registroState.registro.listError.idlocalidad}
              mobileWidth={true}
              isRequired={true}
              heightModificable={35}
              deshabilitaFormulario={deshabilitaFormulario}
              desactivado={deshabilitaFormulario}
            />
          </div>
          <div className="ptur-datos-personales-columna1-fila3">
            <InputV1
              inputType="text"
              name="telefono"
              headerStr="Teléfono fijo"
              placeholderText="011 1234 5678"
              // errorStr="El teléfono fijo es requerido"
              onChange={onInputChange}
              onKeyPress={preventKeyTelefono}
              maxLength="14"
              value={formularioPerfil.telefono}
              className={deshabilitaFormulario ? "rb16t" : "rb16m"}
              isRequired={false}
              deshabilitaFormulario={deshabilitaFormulario}
            />
          </div>
          {(pacienteState.paciente.editaPerfil.estado && changeBotones) && (
          <div className="ptur-datos-personales-columna1-fila4 ptur-datos-personales-columna1-fila4--password">
              <>
                <InputV1
                  inputType={passwordShown ? "text" : "password"}
                  inputMode="numeric"
                  name="txtActual"
                  headerStr="Contraseña actual"
                  placeholderText="********"
                  errorStr="Ingresá la contraseña actual"
                  onChange={onChangeActual}
                  onBlur={onBlurActual}
                  onKeyPress={preventKeySoloNumerosPwd}
                  value={valueActual}
                  className={
                    passwordShown
                      ? "inputNumericShow inputNonScroll rb16m"
                      : "inputNumeric inputNonScroll rb16m"
                  }
                  maxLength={10}
                  checkError={actualError}
                  isRequired={true}
                  deshabilitaFormulario={deshabilitaPwd || pacienteState?.paciente?.loading}
                  refElement={txtActual}
                />
                <InputV1
                  inputType={passwordShown ? "text" : "password"}
                  inputMode="numeric"
                  name="txtPwd"
                  headerStr="Nueva contraseña"
                  placeholderText="********"
                  errorStr="La contraseña es inválida"
                  onChange={onChangePwd}
                  onBlur={onBlurPwd}
                  onKeyPress={preventKeySoloNumerosPwd}
                  value={valuePwd}
                  className={
                    passwordShown
                      ? "inputNumericShow inputNonScroll rb16m"
                      : "inputNumeric inputNonScroll rb16m"
                  }
                  maxLength={10}
                  checkError={pwdError}
                  isRequired={true}
                  deshabilitaFormulario={deshabilitaPwd || pacienteState?.paciente?.loading}
                  refElement={txtPwd}
                />
                {passwordShown === false ? (
                  <button
                    className="ptur-datos-personales-show-hideBtn"
                    disabled={deshabilitaPwd || pacienteState?.paciente?.loading}
                    onClick={() => showPassword()}
                  >
                    <HidePassIcon
                      color={
                        deshabilitaPwd || pacienteState?.paciente?.loading
                          ? "var(--color-grey65)"
                          : "var(--color-latex30)"
                      }
                    />
                  </button>
                ) : (
                  <button
                    className="ptur-datos-personales-show-hideBtn"
                    disabled={deshabilitaPwd || pacienteState?.paciente?.loading}
                    onClick={() => hidePassword()}
                  >
                    <ShowPassIcon
                      color={
                        deshabilitaPwd || pacienteState?.paciente?.loading
                          ? "var(--color-grey65)"
                          : "var(--color-latex30)"
                      }
                    />
                  </button>
                )}
              </>
          </div>
          )}
        </div>
        <div className="ptur-datos-personales-columna2">
          <InputV1
            inputType="email"
            name="email"
            headerStr="Email"
            placeholderText="juan@gmail.com"
            errorStr={
              registroState.registro.usuario.email === ""
                ? "El email es requerido"
                : "El email es inválido"
            }
            onChange={onInputChange}
            onKeyPress={preventKeyEmail}
            maxLength="200"
            value={formularioPerfil.email}
            className={deshabilitaFormulario ? "rb16t" : "rb16m"}
            checkError={registroState.registro.listError.email}
            isRequired={true}
            deshabilitaFormulario={deshabilitaFormulario}
          />
          <InputV1
            inputType="text"
            headerStr="Domicilio"
            name="domicilio"
            placeholderText="Av. Rivadavia 14252"
            errorStr="El domicilio es requerido"
            onChange={onInputChange}
            maxLength="50"
            value={camelize(formularioPerfil.domicilio)}
            className={deshabilitaFormulario ? "rb16t" : "rb16m"}
            checkError={registroState.registro.listError.domicilio}
            isRequired={true}
            deshabilitaFormulario={deshabilitaFormulario}
          />
          <InputV1
            inputType="text"
            name="telefono_movil"
            headerStr="Teléfono móvil"
            placeholderText="011 1234 5678"
            errorStr="Recomendamos ingresar su tel. móvil."
            onChange={onInputChange}
            onKeyPress={preventKeyTelefono}
            maxLength="14"
            value={formularioPerfil.telefono_movil}
            className={deshabilitaFormulario ? "rb16t" : "rb16m"}
            checkError={registroState.registro.listError.telefono_movil}
            isRequired={true}
            deshabilitaFormulario={deshabilitaFormulario}
          />
          <div className="ptur-datos-personales-mobilePassword">
            {pacienteState.paciente.editaPerfil.estado && changeBotones && (
              <>
                <InputV1
                  inputType={passwordShown ? "text" : "password"}
                  inputMode="numeric"
                  name="txtActualMobile"
                  headerStr="Contraseña actual"
                  placeholderText="********"
                  errorStr="Ingresá la contraseña actual"
                  onChange={onChangeActual}
                  onBlur={onBlurActual}
                  onKeyPress={preventKeySoloNumerosPwd}
                  value={valueActual}
                  className={
                    passwordShown
                      ? "inputNumericShow inputNonScroll rb16m"
                      : "inputNumeric inputNonScroll rb16m"
                  }
                  maxLength={10}
                  checkError={actualError}
                  isRequired={true}
                  deshabilitaFormulario={deshabilitaPwd || pacienteState?.paciente?.loading}
                  refElement={txtActual}
                />
                <InputV1
                  inputType={passwordShown ? "text" : "password"}
                  inputMode="numeric"
                  name="txtPwdMobile"
                  headerStr="Nueva contraseña"
                  placeholderText="********"
                  errorStr="La contraseña es inválida"
                  onChange={onChangePwd}
                  onBlur={onBlurPwd}
                  onKeyPress={preventKeySoloNumerosPwd}
                  value={valuePwd}
                  className={
                    passwordShown
                      ? "inputNumericShow inputNonScroll rb16m"
                      : "inputNumeric inputNonScroll rb16m"
                  }
                  maxLength={10}
                  checkError={pwdError}
                  isRequired={true}
                  deshabilitaFormulario={deshabilitaPwd || pacienteState?.paciente?.loading}
                  refElement={txtPwdMobile}
                />
                {passwordShown === false ? (
                  <button
                    className="ptur-datos-personales-show-hideBtnMobile"
                    disabled={deshabilitaPwd || pacienteState?.paciente?.loading}
                    onClick={() => showPassword()}
                  >
                    <HidePassIcon
                      color={
                        deshabilitaPwd || pacienteState?.paciente?.loading
                          ? "var(--color-grey65)"
                          : "var(--color-latex30)"
                      }
                    />
                  </button>
                ) : (
                  <button
                    className="ptur-datos-personales-show-hideBtnMobile"
                    disabled={deshabilitaPwd || pacienteState?.paciente?.loading}
                    onClick={() => hidePassword()}
                  >
                    <ShowPassIcon
                      color={
                        deshabilitaPwd || pacienteState?.paciente?.loading
                          ? "var(--color-grey65)"
                          : "var(--color-latex30)"
                      }
                    />
                  </button>
                )}
              </>
            )}
            <div className="ptur-datos-personales-cambioClaveMobile-box">
              {!changeBotones ? (
                <button
                  className="ptur-datos-personales-contraseña rb14m"
                  onClick={onClickChangePwdMobile}
                  disabled={
                    !pacienteState.paciente.editaPerfil.estado ||
                    pacienteState.paciente.userSelect.pacienteSeleccionado
                  }
                >
                  Cambiar contraseña
                </button>
              ) : (
                <div className="ptur-datos-personales-boxBtnsPwd ptur-datos-personales-boxBtnsPwd--mobile">
                  <button
                    type="button"
                    className="ptur-datos-personales-btnCancelarPwd rb14m"
                    onClick={onClickCancelPwdMobile}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="ptur-datos-personales-btnGuardarPwd rb14m"
                    onClick={onClickSavePwdMobile}
                    disabled={
                      valueActual === "" ||
                      valuePwd === "" ||
                      pacienteState?.paciente?.loading
                    }
                  >
                    Guardar
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="ptur-datos-personales-boxContraseña">
            {!changeBotones ? (
              <button
                className="ptur-datos-personales-contraseña rb18m"
                onClick={() => habilitaCambioPwd()}
                disabled={
                  !pacienteState.paciente.editaPerfil.estado ||
                  pacienteState.paciente.userSelect.pacienteSeleccionado
                }
              >
                Cambiar contraseña
              </button>
            ) : (
              <div className="ptur-datos-personales-boxBtnsPwd">
                <button
                  type="button"
                  className="ptur-datos-personales-btnCancelarPwd rb18m"
                  onClick={() => cancelaCambioPwd()}
                >
                  Cancelar
                </button>
                <button
                    type="button"
                    className={`ptur-datos-personales-btnGuardarPwd rb18m ${
                    valueActual === "" || valuePwd === "" || pacienteState?.paciente?.loading
                      ? "ptur-datos-personales-btnGuardarPwd--disabled"
                      : ""
                  }`}
                  onClick={
                    valueActual !== "" && valuePwd !== "" && !pacienteState?.paciente?.loading
                      ? () => cambioClave()
                      : () => {}
                  }
                  disabled={
                    valueActual === "" ||
                    valuePwd === "" ||
                    pacienteState?.paciente?.loading
                  }
                >
                  Guardar
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DatosPersonales;
